import { Stack } from '@mantine/core';
import { BiMetricConfig } from '@repo/api-codegen';
import CollapsableStack from '@repo/common/components/CollapsableStack';
import { observer } from 'mobx-react-lite';
import { CategorySection } from './CategorySection.tsx';
import { ChartTypeSelector } from './ChartTypeSelector';
import { VisualSection } from './VisualSection.tsx';
import { XAxisSection } from './XAxisSection.tsx';
import { YAxisSection } from './YAxisSection.tsx';

interface BIMetricEditorProps {
	chartConfig: BiMetricConfig['chart_config'];
	onUpdate: (config: BiMetricConfig['chart_config']) => void;
	results: Record<string, any>[];
}

export const BiMetricEditor = observer(
	({ chartConfig, onUpdate, results }: BIMetricEditorProps) => {
		// Only show category axis selector for chart types that support it
		const supportsCategoryAxis =
			chartConfig.chartType === 'bar' ||
			chartConfig.chartType === 'line' ||
			chartConfig.chartType === 'scatter';

		const supportXAxis = chartConfig.chartType !== 'table';
		const supportYAxis = chartConfig.chartType !== 'table';
		const supportVisual = chartConfig.chartType !== 'table';

		return (
			<Stack>
				<CollapsableStack groupName="Chart type">
					<ChartTypeSelector
						chartConfig={chartConfig}
						onUpdate={onUpdate}
						results={results}
					/>
				</CollapsableStack>
				{supportXAxis && (
					<CollapsableStack groupName="X-axis">
						<XAxisSection chartConfig={chartConfig} onUpdate={onUpdate} />
					</CollapsableStack>
				)}
				{supportYAxis && (
					<CollapsableStack groupName="Y-axis">
						<YAxisSection chartConfig={chartConfig} onUpdate={onUpdate} />
					</CollapsableStack>
				)}
				{supportsCategoryAxis && (
					<CollapsableStack groupName="Category">
						<CategorySection chartConfig={chartConfig} onUpdate={onUpdate} />
					</CollapsableStack>
				)}
				{supportVisual && (
					<CollapsableStack groupName="Visual">
						<VisualSection chartConfig={chartConfig} onUpdate={onUpdate} />
					</CollapsableStack>
				)}
			</Stack>
		);
	}
);
